
import { BREAKPOINT } from '@angular/flex-layout';

// straight copy from DEFAULT_BREAKPOINTS from the lib. tweaked only the values we care about.
// the 'desktop' boolean used is toggled when screen is: !xs && !sm
// moved upper limit of sm to be 1200px, original lines commented out.

export const CUSTOM_BREAKPOINTS = [
  { alias: 'xs', mediaQuery: 'screen and (min-width: 0px) and (max-width: 599.9px)', priority: 1000, suffix: 'Xs', overlapping: false },
  // { alias: 'sm', mediaQuery: 'screen and (min-width: 600px) and (max-width: 959.9px)', priority: 900, suffix: 'Sm', overlapping: false },
  { alias: 'sm', mediaQuery: 'screen and (min-width: 600px) and (max-width: 1199.9px)', priority: 900, suffix: 'Sm', overlapping: false },
  // { alias: 'md', mediaQuery: 'screen and (min-width: 960px) and (max-width: 1279.9px)', priority: 800, suffix: 'Md', overlapping: false },
  { alias: 'md', mediaQuery: 'screen and (min-width: 1200px) and (max-width: 1279.9px)', priority: 800, suffix: 'Md', overlapping: false },
  { alias: 'lg', mediaQuery: 'screen and (min-width: 1280px) and (max-width: 1919.9px)', priority: 700, suffix: 'Lg', overlapping: false },
  { alias: 'xl', mediaQuery: 'screen and (min-width: 1920px) and (max-width: 4999.9px)', priority: 600, suffix: 'Xl', overlapping: false },
  { alias: 'lt-sm', overlapping: true, mediaQuery: 'screen and (max-width: 599.9px)', priority: 950, suffix: 'LtSm' },
  // { alias: 'lt-md', overlapping: true, mediaQuery: 'screen and (max-width: 959.9px)', priority: 850, suffix: 'LtMd' },
  { alias: 'lt-md', overlapping: true, mediaQuery: 'screen and (max-width: 1199.9px)', priority: 850, suffix: 'LtMd' },
  { alias: 'lt-lg', overlapping: true, mediaQuery: 'screen and (max-width: 1279.9px)', priority: 750, suffix: 'LtLg' },
  { alias: 'lt-xl', overlapping: true, priority: 650, mediaQuery: 'screen and (max-width: 1919.9px)', suffix: 'LtXl' },
  { alias: 'gt-xs', overlapping: true, mediaQuery: 'screen and (min-width: 600px)', priority: -950, suffix: 'GtXs' },
  // { alias: 'gt-sm', overlapping: true, mediaQuery: 'screen and (min-width: 960px)', priority: -850, suffix: 'GtSm' },
  { alias: 'gt-sm', overlapping: true, mediaQuery: 'screen and (min-width: 1200px)', priority: -850, suffix: 'GtSm' },
  { alias: 'gt-md', overlapping: true, mediaQuery: 'screen and (min-width: 1280px)', priority: -750, suffix: 'GtMd' },
  { alias: 'gt-lg', overlapping: true, mediaQuery: 'screen and (min-width: 1920px)', priority: -650, suffix: 'GtLg' },
];

export const CustomBreakPointsProvider = {
  provide: BREAKPOINT,
  useValue: CUSTOM_BREAKPOINTS,
  multi: true
};
